import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import coreCs from './core/cs.json';
import coreEn from './core/en.json';
import coreSk from './core/sk.json';

import flowCs from './flow/cs.json';
import flowEn from './flow/en.json';
import flowSk from './flow/sk.json';

import cs from './general/cs.json';
import en from './general/en.json';
import sk from './general/sk.json';

import heliosCs from './helios/cs.json';
import heliosEn from './helios/en.json';
import heliosSk from './helios/sk.json';

import userCs from './user/cs.json';
import userEn from './user/en.json';
import userSk from './user/sk.json';

const translationsJson = {
  cs: {
    translation: {
      ...cs,
      core: coreCs,
      flow: flowCs,
      helios: heliosCs,
      user: userCs,
    },
  },
  en: {
    translation: {
      ...en,
      core: coreEn,
      flow: flowEn,
      helios: heliosEn,
      user: userEn,
    },
  },
  sk: {
    translation: {
      ...sk,
      core: coreSk,
      flow: flowSk,
      helios: heliosSk,
      user: userSk,
    },
  },
};

export const i18n = i18next.use(initReactI18next).init({
  resources: translationsJson,
  fallbackLng: ['cs', 'sk', 'en'],
  returnObjects: true,
  interpolation: {
    skipOnVariables: false,
    escapeValue: false,
  },
});
